module.exports = __webpack_public_path__ + "static/media/icon_nav_kpi.7e37f92a.svg";